module.exports = __webpack_public_path__ + "static/media/product.874008a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/product.svg
// module id = 201
// module chunks = 0